var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',_vm._b({staticClass:"indent-input",attrs:{"value":_vm.value,"allowClear":""},on:{"change":_vm.handleChange,"blur":_vm.handleBlur,"focus":_vm.handleFocus}},'Input',_vm.$attrs,false),[(!_vm.searchFocus)?_c('template',{slot:"prefix"},[_c('SvgIcon',{attrs:{"icon-class":"search"}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }